import { Component } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { SharedModule } from "@shared/shared.module";

@Component({
	selector: "app-accessibility",
	imports: [
		SharedModule,
		TranslatePipe
	],
	templateUrl: "./accessibility.component.html",
	styleUrl: "./accessibility.component.scss",
})
export class AccessibilityComponent { }